import React from 'react'
import "./BybCancelRefund.css"
import HeaderNavbar from '../BybNavbar/HeaderNavbar'
import BybFooter from '../BybFooter/BybFooter'
function BybCancelRefund() {
  return (
    <>
            <HeaderNavbar/>

            <section className="byb-cancelrefund">
        <div className="container">
          <div className="byb-cancelrefund-header">
            <h4>Cancellation and Refund Policy</h4>
          </div>

          <div className="cancelrefund-content">
            <h6>Order Cancellations</h6>
            <p>
            Due to the custom nature of the Brew Your Brand - Brand Audit Kit, cancellations and refunds are not available once an order is placed. Each kit is produced on a per-order basis to ensure quality and customization for each customer.
            </p>

            <h6>Damaged or Missing Items</h6>
            <p>
            If your Brand Audit Kit arrives damaged or is missing components, please contact us at <a href="mailto:support@brewyourbrand.in ">support@brewyourbrand.in </a> within 7 days of receiving the product. We will work with you to arrange a replacement of any defective or missing items.
            </p>

            <h6>Non-Refundable</h6>
            <p>
            Please note that all sales are final, and refunds will not be issued under any circumstances, except where required by applicable laws.
            </p>

            <p>
              For questions or issues regarding shipping and delivery, please
              contact us at <a href="support@brewyourbrand.in">support@brewyourbrand.in</a> 
            </p>
          </div>
        </div>
      </section>

      <BybFooter/>

    </>
  )
}

export default BybCancelRefund
